<template>
  <div class="w-full">
    <PreviewModal
      :isModal="isShowPreviewModal"
      @onClose="onPreviewClose"
      @confirm="onPreviewConfirm"
      :previewSrc="currentPreviewSrc"
    />

    <Modal
      :title="$t('PreviouslyUploadedFiles')"
      v-model="props.isModal"
      :isShowClose="false"
      containerClass="w-2/5 max-w-[600px]  p-2"
    >
      <template #bodyContent>
        <div class="flex flex-col gap-y-6 mb-6">
          <div class="flex flex-col" v-for="(item, key) in producedList" :key="key">
            <div class="flex py-3 font-bold">{{ item?.extract?.text }}</div>
            <div class="flex py-4 px-7 border border-dashed rounded-md gap-x-4">
              <div @click="onShowPreviewModal(item)">
                <img
                  v-if="item?.imgSrc"
                  :src="item?.imgSrc"
                  class="w-[50px] h-[50px] cursor-pointer"
                />
                <faFilePdf v-else class="w-6" />
              </div>
              <div class="flex flex-col items-start justify-center">
                <div class="text-brand-black-body text-sm">{{ item?.content?.name }}</div>
                <div class="text-brand-black-autofill text-[12px]">
                  {{ byteSize(item?.content?.size || 0, { units: 'iec' }) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footerContent>
        <div class="flex justify-end items-center gap-x-4">
          <BorderButton :label="$t('No')" @click.prevent="onClose" />
          <FilledButton
            class="px-5 py-1.5 text-white flex gap-2 items-center"
            @click.prevent="onConfirm"
          >
            {{ $t('AutoFill') }}
          </FilledButton>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script setup>
import { onMounted, ref, watch } from 'vue'
import byteSize from 'byte-size'
import Modal from '@/components/Ui/Modal/index.vue'
import BorderButton from '@/components/Buttons/BorderButton.vue'
import FilledButton from '@/components/Buttons/Filled.vue'
import PreviewModal from '@/views/files-autofill/PreviewModal.vue'
import faFilePdf from '@/assets/icons/faFilePdf.svg?component'

const emits = defineEmits(['onClose', 'confirm'])
const props = defineProps({
  isModal: {
    type: Boolean,
    default: () => false
  },
  list: {
    type: Array,
    required: true
  }
})
const isShowPreviewModal = ref(false)
const producedList = ref([])
const currentPreviewSrc = ref()

const renderImgForPreview = (imageObj) => {
  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    reader.onload = function (event) {
      resolve(event.target.result)
    }
    reader.readAsDataURL(imageObj)
  })
}

const onConfirm = () => {
  emits('confirm')
}
const onClose = () => {
  emits('onClose')
}

const onShowPreviewModal = (item) => {
  if (item?.content?.type !== 'image/jpeg') {
    return
  }
  isShowPreviewModal.value = true
  currentPreviewSrc.value = item.imgSrc
}

const onPreviewClose = () => {
  isShowPreviewModal.value = false
}

const onPreviewConfirm = () => {
  isShowPreviewModal.value = false
}

watch(
  () => props.isModal,
  async (newValue) => {
    if (!newValue) return

    producedList.value = []
    for (let index = 0; index < props.list.length; index++) {
      const item = props.list[index]
      let imgSrc
      if (item?.content?.type === 'image/jpeg') {
        imgSrc = await renderImgForPreview(item?.content)
      }
      item.imgSrc = imgSrc
      producedList.value.push(item)
    }
  }
)
</script>
<script>
export default {
  name: 'FilledListModal'
}
</script>
